// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_G","related":"e_H","breadCrumbs":"e_I","postTags":"e_J","sidebarPostNav":"e_K"};